// import { useState, useEffect } from "react";
// import { toFeetInches } from "../lib/Utils";

// const LockerModalContent = ({
//   lockerInfos,
//   selectedSlotId,
//   onConfirm,
//   onCancel,
// }) => {
//   const [selectedSlot, setSelectedSlot] = useState(null);

//   // ✅ Preselect slot if already chosen
//   useEffect(() => {
//     if (lockerInfos?.bookingSlots) {
//       const found =
//         lockerInfos.bookingSlots.find(
//           (slot) => slot.id === selectedSlotId
//         ) || lockerInfos.bookingSlots[0];

//       setSelectedSlot(found);
//     }
//   }, [lockerInfos, selectedSlotId]);

//   const handleSlotChange = (slot) => {
//     setSelectedSlot(slot);
//   };

//   const handleConfirm = () => {
//     if (onConfirm) {
//       onConfirm({
//         slot_id: selectedSlot?.id,
//       });
//     }
//   };

//   const convertToInch = (w, d, h) => {
//     if (!w || !d || !h) return "";
//     return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
//   };

//   if (!lockerInfos) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="locker-modal">
//         <h2 className="modal-title">Choose Your Locker</h2>

//         {/* HEADER */}
//         <div className="locker-header">
//           <div className="locker-left">
//             <div className="locker-icon">
//               {lockerInfos?.code || lockerInfos?.name || "NA"}
//             </div>

//             <div className="locker-info">
//               <div className="locker-name">Dimensions</div>
//               <div className="locker-dimension">
//                 {convertToInch(
//                   lockerInfos?.width,
//                   lockerInfos?.depth,
//                   lockerInfos?.height
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* SLOT LIST */}
//         <div className="slot-list">
//           {lockerInfos?.bookingSlots?.map((slot) => (
//             <label
//               key={slot.id}
//               className={`slot ${
//                 selectedSlot?.id === slot.id ? "active" : ""
//               }`}
//             >
//               <div className="left">
//                 <input
//                   type="radio"
//                   checked={selectedSlot?.id === slot.id}
//                   onChange={() => handleSlotChange(slot)}
//                 />
//                 <span>{slot.durationRange}</span>
//               </div>

//               <div className="price">₹ {slot.price}</div>
//             </label>
//           ))}
//         </div>

//         {/* TOTAL */}
//         <div className="total-cost">
//           <span>Total</span>
//           <span>₹ {selectedSlot?.price || 0}</span>
//         </div>

//         {/* ACTIONS */}
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={onCancel}>
//             Cancel
//           </button>

//           <button
//             className="select-btn"
//             onClick={handleConfirm}
//             disabled={!selectedSlot}
//           >
//             Select Slot
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LockerModalContent;


import { useState, useEffect } from "react";
import { toFeetInches } from "../lib/Utils";

const LockerModalContent = ({
  lockerInfos,
  selectedDuration,
  onConfirm,
  onCancel,
}) => {
  const [selectedSlot, setSelectedSlot] = useState(null);

  // ✅ Preselect slot based on global duration
  useEffect(() => {
    if (lockerInfos?.bookingSlots?.length > 0) {
      const defaultSlot =
        lockerInfos.bookingSlots.find(
          (slot) =>
            slot.durationInMilliseconds === selectedDuration
        ) || lockerInfos.bookingSlots[0];

      setSelectedSlot(defaultSlot);
    }
  }, [lockerInfos, selectedDuration]);

  const handleSlotChange = (slot) => {
    setSelectedSlot(slot);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({
        slot: selectedSlot,
        durationInMilliseconds:
          selectedSlot?.durationInMilliseconds,
      });
    }
  };

  const convertToInch = (w, d, h) => {
    if (!w || !d || !h) return "";
    return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
  };

  if (!lockerInfos) return null;

  return (
    <div className="modal-overlay">
      <div className="locker-modal">
        <h2 className="modal-title">Choose Your Locker</h2>

        {/* HEADER */}
        <div className="locker-header">
          <div className="locker-left">
            <div className="locker-icon">
              {lockerInfos?.code || lockerInfos?.name || "NA"}
            </div>

            <div className="locker-info">
              <div className="locker-name">Dimensions</div>
              <div className="locker-dimension">
                {convertToInch(
                  lockerInfos?.width,
                  lockerInfos?.depth,
                  lockerInfos?.height
                )}
              </div>
            </div>
          </div>
        </div>

        {/* SLOT LIST */}
        <div className="slot-list">
          {lockerInfos?.bookingSlots?.map((slot) => (
            <label
              key={slot.id}
              className={`slot ${
                selectedSlot?.id === slot.id ? "active" : ""
              }`}
            >
              <div className="left">
                <input
                  type="radio"
                  checked={selectedSlot?.id === slot.id}
                  onChange={() => handleSlotChange(slot)}
                />
                <span>{slot.durationRange}</span>
              </div>

              <div className="price">
                ₹ {slot.price}
              </div>
            </label>
          ))}
        </div>

        {/* TOTAL */}
        <div className="total-cost">
          <span>Total</span>
          <span>₹ {selectedSlot?.price || 0}</span>
        </div>

        {/* ACTIONS */}
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onCancel}>
            Cancel
          </button>

          <button
            className="select-btn"
            onClick={handleConfirm}
            disabled={!selectedSlot}
          >
            Select Slot
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockerModalContent;

// import { useState, useEffect } from "react";
// import { toFeetInches } from "../lib/Utils";

// const LockerModalContent = ({
//   lockerInfos,
//   selectedDuration,
//   onConfirm,
//   onCancel,
// }) => {
//   const [selectedSlot, setSelectedSlot] = useState(null);

//   // ✅ PRESELECT SLOT
//   useEffect(() => {
//     if (lockerInfos?.bookingSlots?.length > 0) {
//       const defaultSlot =
//         lockerInfos.bookingSlots.find(
//           (slot) =>
//             slot.durationInMilliseconds === selectedDuration
//         ) || lockerInfos.bookingSlots[0];

//       setSelectedSlot(defaultSlot);
//     }
//   }, [lockerInfos, selectedDuration]);

//   const handleConfirm = () => {
//     if (!selectedSlot) return;

//     onConfirm({
//       durationInMilliseconds:
//         selectedSlot.durationInMilliseconds,
//     });
//   };

//   const convertToInch = (w, d, h) => {
//     if (!w || !d || !h) return "";
//     return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
//   };

//   if (!lockerInfos) return null;

//   return (
//     <div className="modal-overlay">
//       <div className="locker-modal">
//         <h2 className="modal-title">Choose Your Locker</h2>

//         {/* HEADER */}
//         <div className="locker-header">
//           <div className="locker-left">
//             <div className="locker-icon">
//               {lockerInfos?.code || lockerInfos?.name || "NA"}
//             </div>

//             <div className="locker-info">
//               <div className="locker-name">Dimensions</div>
//               <div className="locker-dimension">
//                 {convertToInch(
//                   lockerInfos?.width,
//                   lockerInfos?.depth,
//                   lockerInfos?.height
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* SLOT LIST */}
//         <div className="slot-list">
//           {lockerInfos?.bookingSlots?.map((slot) => (
//             <label
//               key={slot.id}
//               className={`slot ${
//                 selectedSlot?.id === slot.id ? "active" : ""
//               }`}
//             >
//               <div className="left">
//                 <input
//                   type="radio"
//                   checked={selectedSlot?.id === slot.id}
//                   onChange={() => setSelectedSlot(slot)}
//                 />
//                 <span>{slot.durationRange}</span>
//               </div>

//               <div className="price">₹ {slot.price}</div>
//             </label>
//           ))}
//         </div>

//         {/* TOTAL */}
//         <div className="total-cost">
//           <span>Total</span>
//           <span>₹ {Number(selectedSlot?.price || 0)}</span>
//         </div>

//         {/* ACTIONS */}
//         <div className="modal-actions">
//           <button className="cancel-btn" onClick={onCancel}>
//             Cancel
//           </button>

//           <button
//             className="select-btn"
//             onClick={handleConfirm}
//             disabled={!selectedSlot}
//           >
//             Select Slot
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LockerModalContent;